module.exports = __webpack_public_path__ + "img/06.3191f93d.png";